<h2>{{'Informazioni Base' | translate}}</h2>

<div class='full-form' [ngClass]='formConfig.formStyle'>
  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' mode="indeterminate"></mat-progress-bar>
  }
  @if (bookingService.canEdit) {
    <form-viewer
      #formViewer
      [dataContainerService]='datasetACS'
      [record]='datasetRS.record.value'
      [formConfig]='formConfig'
    ></form-viewer>
  }
  @if (!bookingService.canEdit) {
    <data-container-viewer
      [fields]='formConfig.fields'
      [record]='datasetRS.record.value'
      [dataContainerService]='datasetACS'
    ></data-container-viewer>
  }
</div>